/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Report_ViewInputs */



/**
* | output |
* | --- |
* | "View" |
*
* @param {Practice_Report_ViewInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_report_view = /** @type {((inputs?: Practice_Report_ViewInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Report_ViewInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bekijk")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher")
	return /** @type {LocalizedString} */ ("View")
});